import Modal from 'react-bootstrap/Modal';

function KioskModal({ show, onHide, labelledBy, confirm = false, children }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={confirm ? 'kioskModal kioskModal--confirm' : 'kioskModal'}
      contentClassName={confirm ? 'uploadQr__dialog readyModal__dialog' : 'uploadQr__dialog'}
      aria-labelledby={labelledBy}
    >
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}

export default KioskModal;
